import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
declare var FB: any;
@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent implements OnInit {
  userId: string;
  userAccessToken: string;
  showAuthUser: boolean;
  applicationId: string;
  resultFacebook: any;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    // this.applicationId = '478360366444487';  // **Enter your Created FB App's ID**
    // this.userId = localStorage.getItem('userID');
    // this.userAccessToken = localStorage.getItem('userAccessToken');
    // this.loadFBSDK();
    this.authService.generateFbAuthUrl().subscribe(resFbAuthUrl => {
      if (resFbAuthUrl.status === 'verified') {
        window.location.href = 'http://localhost:4300/helpdesk/ticket-view/all';
      } else if (resFbAuthUrl.status === 'unverified') {
        window.location.href = resFbAuthUrl.auth_url;
      } else {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  loadFBSDK() {
    ( window as any).fbAsyncInit = () => {
      FB.init({
        appId: this.applicationId,
        xfbml: false,
        version: 'v2.9'
      });
    };

    ((d, s, id) => {
      let js: any;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  oauthLogin() {
    FB.login((loginResponse) => {
      console.log(loginResponse);
      if (loginResponse.status === 'connected') {
        this.userId = loginResponse.authResponse.userID;
        this.userAccessToken = loginResponse.authResponse.accessToken;
        localStorage.setItem('userID', loginResponse.authResponse.userID);
        localStorage.setItem('userAccessToken', loginResponse.authResponse.accessToken);
        this.authService.setSocialCredentials(loginResponse.authResponse, 'profile', 'facebook').subscribe(res => {
          console.log(res);
        });
      }
    }, { scope: 'public_profile,email,manage_pages,pages_show_list,pages_messaging' });
  }

  getPageAccessToken() {
    FB.api(
      '/' + this.userId + '/accounts?access_token=' + this.userAccessToken,
      (result) => {
        console.log(result);
        if (result && !result.error) {
          result.data.forEach(pageToken => {
            this.authService.setSocialCredentials(pageToken, 'page', 'facebook').subscribe(res => {
              console.log(res);
            });
          });
          this.resultFacebook = result;
        } else {
        }
      });
  }

  getUserInfo() {
    console.log('UserId' + this.userId);
    FB.api(
      '/' + this.userId + '?fields=name,accounts,email',
      (result) => {
        if (result && !result.error) {
          this.resultFacebook = result;
        } else {
        }
      });
  }

  getSubscribedApps() {
    /* make the API call */
    FB.api(
      // tslint:disable-next-line: max-line-length
      '/102086531247020/subscribed_apps?access_token=EAAGzEPO3b8cBAFBMFZBOS6iOyoLQApUIvC5oTdK4oaDMf8eWusZANEgo1LiTxZCq9rsHTEftNy336CFlvGrTaGly6RcHG1p0NZBYGlRHNMns9w52d4qgVw7JGs131bBJ1kJ7CQPLQZAtkr4mnzGB6o5fEodF6HPtxjVQTeQX80JZBQIjQCUiMZBulCI3Cp8LRmOqeSua93TvZBtOUNEST74n',
      'POST',
      {
        subscribed_fields: 'messages'
      },
      (response) => {
        if (response && !response.error) {
          /* handle the result */
          console.log(response);
        } else {
          console.log(response.error);
        }
      }
    );
  }

}
